import React from "react";
import {
  FormInput as BaseFormInput,
  FormSelect as BaseFormSelect,
  SearchableSelect as BaseSearchableSelect,
  FormTextarea as BaseFormTextarea,
} from "../../../components/ui";

const labelClass = "text-slate-700 font-bold text-[11px] tracking-wide capitalize";
const inputClass = "text-[13px] font-medium text-slate-800 bg-white border-slate-200 focus:border-slate-800 transition-all h-[35px] shadow-sm rounded-md [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [-moz-appearance:textfield]";

export const FormInput = React.forwardRef((props, ref) => <BaseFormInput ref={ref} {...props} labelClassName={labelClass} inputClassName={inputClass} />);
FormInput.displayName = "FormInput";

export const FormSelect = React.forwardRef((props, ref) => <BaseFormSelect ref={ref} {...props} labelClassName={labelClass} inputClassName={inputClass} />);
FormSelect.displayName = "FormSelect";

export const FormTextarea = React.forwardRef((props, ref) => <BaseFormTextarea ref={ref} {...props} labelClassName={labelClass} inputClassName={inputClass} />);
FormTextarea.displayName = "FormTextarea";

export const SearchableSelect = React.forwardRef((props, ref) => <BaseSearchableSelect ref={ref} {...props} labelClassName={labelClass} />);
SearchableSelect.displayName = "SearchableSelect";
